<template lang="pug">
include /mixins

+b.c-event-wrapper(
  :class="{ 'is-scrolled': !clamped && items.length > 12 }"
)
  +e.item(v-for="item in clampedItems")
    +b.c-dot.--variant_1(
      v-if="item.isDot"
      :style="{ '--dot-color': item.color }"
      @click.stop="$emit('event:select', item)"
    )
      +e.dot
      +e.SPAN.content.--variant_ellipsis {{ item.title }}
    //- +b.c-badge.is-bordered(
    //-   v-else-if="item.isAudit"
    //-   :style="{ '--badge-border-color': item.color }"
    //-   @click.stop="$emit('event:select', item)"
    //- )
    //-   +e.SPAN.text {{ item.title }}
    //- +b.c-badge.is-bordered-dark(
    //-   v-else-if="item.isProgress"
    //-   :style="{ '--badge-color': item.color }"
    //-   @click.stop="$emit('event:select', item)"
    //- )
    //-   +e.SPAN.text {{ item.title }}
    +b.c-badge(
      v-else
      :style="{ '--badge-color': item.color }"
      @click.stop="$emit('event:select', item)"
    )
      +e.SPAN.text {{ item.title }}
  +e.item(v-if="clamped && items.length > $options.MAX_ITEMS")
    +b.c-badge.is-transparent(
      @click.stop="$emit('event:more')"
    )
      +e.SPAN.text {{ _("Ще") }} {{ showMoreCount }}
</template>

<script>
const MAX_ITEMS = 4

export default {
  MAX_ITEMS,

  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    clamped: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    clampedItems() {
      return this.clamped ? this.items.slice(0, MAX_ITEMS) : this.items
    },

    showMoreCount() {
      return this.items.length - MAX_ITEMS
    },
  },
}
</script>
